function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#595959;}\n\t.st1{fill:#158CD6;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M150.5,57.1c-4.4,0-8.7,1.4-13,4.1c-4.3,2.7-7.6,6.3-10.1,10.7h-1.4l-4.5-13.3h-21.4v83.5h28.8v-41 c0-5.4,1.4-9.5,4.3-12.4c2.8-2.9,7.4-4.3,13.7-4.3c4.2,0,7.4,0.3,9.8,0.9l2.6-27.2l-1.6-0.3C155.4,57.3,153,57.1,150.5,57.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M56,57.1c-9.4,0-16.8,4-22.2,12.1h-1.3l-4.1-10.6H5v119.7h28.8v-33.5c0-1.4-0.4-5.1-1.3-10.9h1.3 c3.3,3.6,6.6,6.2,9.9,7.6c3.3,1.4,7.1,2.1,11.3,2.1c9.4,0,16.8-3.9,22.3-11.6c5.5-7.7,8.2-18.3,8.2-31.8c0-13.4-2.6-23.9-7.9-31.5 C72.4,61,65.2,57.1,56,57.1z M53.8,115.6c-1.7,3.2-4.3,4.8-8,4.8c-4.1,0-7.1-1.6-9.1-4.8c-1.9-3.2-2.9-8.4-2.9-15.5v-2.3 c0.1-5.9,1.1-10.4,2.8-13.4c1.7-3,4.7-4.5,8.9-4.5c3.9,0,6.7,1.6,8.3,4.7c1.7,3.1,2.5,8.3,2.5,15.4 C56.3,107.2,55.4,112.4,53.8,115.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M228.3,62.4c-6.3-3.5-13.5-5.2-21.7-5.2c-13.3,0-23.6,3.8-30.9,11.3c-7.3,7.5-11,18.1-11,31.7 c0,13.3,3.7,23.9,11.2,31.7c7.5,7.8,17.6,11.7,30.2,11.7c13.2,0,23.5-3.8,30.8-11.5c7.3-7.6,11-18.3,11-31.9 c0-8.7-1.7-16.3-5.1-22.8C239.4,70.9,234.5,65.9,228.3,62.4z M215.9,116.6c-1.8,3.8-5,5.6-9.5,5.6c-4.5,0-7.7-1.9-9.7-5.6 c-1.9-3.8-2.9-9.2-2.9-16.4c0-7.2,1-12.6,2.9-16.2c1.9-3.6,5.1-5.4,9.5-5.4c4.5,0,7.7,1.8,9.6,5.5c1.9,3.6,2.8,9,2.8,16.1 C218.6,107.3,217.7,112.8,215.9,116.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M296.4,49.8c1-1.3,2.6-2,4.8-2c3.4,0,6.9,0.5,10.4,1.5l6.2-18.6c-4.5-1.5-8.5-2.5-11.9-3.1 c-3.4-0.6-7-0.9-10.9-0.9c-9.9,0-17.1,2.4-21.6,7.2c-4.5,4.8-6.7,12.7-6.7,23.7V59L255,66.1v14.1h11v61.9h28.8V80.2h17.8V58.6 h-17.8v-2.2C294.9,53.4,295.4,51.2,296.4,49.8z"
}), React.createElement("rect", {
  x: 327.5,
  y: 58.6,
  className: "st0",
  width: 28.8,
  height: 83.5
}), React.createElement("path", {
  className: "st0",
  d: "M341.9,23.4c-8,0-14.4,6.4-14.4,14.4c0,8,6.4,14.4,14.4,14.4c8,0,14.4-6.4,14.4-14.4 C356.3,29.8,349.8,23.4,341.9,23.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M405.7,112.7V80.2h20.5V58.6h-20.5V37.8h-18.9l-7.4,21.7l-12.8,9.1v11.7h10.1v34.4c0,9.8,2.1,17.1,6.4,21.8 c4.3,4.7,11.2,7.1,20.9,7.1c4.7,0,8.8-0.4,12.3-1.1c3.5-0.7,7.2-1.9,11.1-3.6v-21c-5.4,1.9-10,2.9-13.9,2.9 C408.3,120.8,405.7,118.1,405.7,112.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M494.7,57.1c-9.4,0-16.8,4-22.2,12.1h-1.3l-4.1-10.6h-23.4v119.7h28.8v-33.5c0-1.4-0.4-5.1-1.3-10.9h1.3 c3.3,3.6,6.6,6.2,9.9,7.6c3.3,1.4,7.1,2.1,11.3,2.1c9.4,0,16.8-3.9,22.3-11.6c5.5-7.7,8.2-18.3,8.2-31.8c0-13.4-2.6-23.9-7.9-31.5 C511.2,61,503.9,57.1,494.7,57.1z M492.5,115.6c-1.7,3.2-4.3,4.8-8,4.8c-4.1,0-7.1-1.6-9.1-4.8c-1.9-3.2-2.9-8.4-2.9-15.5v-2.3 c0.1-5.9,1.1-10.4,2.8-13.4c1.7-3,4.7-4.5,8.9-4.5c3.9,0,6.7,1.6,8.3,4.7c1.7,3.1,2.5,8.3,2.5,15.4 C495,107.2,494.1,112.4,492.5,115.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M598.8,62.4c-6.3-3.5-13.5-5.2-21.7-5.2c-13.3,0-23.6,3.8-30.9,11.3c-7.3,7.5-11,18.1-11,31.7 c0,13.3,3.7,23.9,11.2,31.7c7.5,7.8,17.6,11.7,30.2,11.7c13.2,0,23.5-3.8,30.8-11.5c7.3-7.6,11-18.3,11-31.9 c0-8.7-1.7-16.3-5.1-22.8C609.9,70.9,605,65.9,598.8,62.4z M586.3,116.6c-1.8,3.8-5,5.6-9.5,5.6c-4.5,0-7.7-1.9-9.7-5.6 c-1.9-3.8-2.9-9.2-2.9-16.4c0-7.2,1-12.6,2.9-16.2c1.9-3.6,5.1-5.4,9.5-5.4c4.5,0,7.7,1.8,9.6,5.5c1.9,3.6,2.8,9,2.8,16.1 C589.1,107.3,588.2,112.8,586.3,116.6z"
}), React.createElement("rect", {
  x: 631.8,
  y: 58.6,
  className: "st1",
  width: 28.8,
  height: 83.5
}), React.createElement("path", {
  className: "st1",
  d: "M705.2,105.5c0-9.4,1.1-16.1,3.2-20c2.2-3.9,5.7-5.8,10.5-5.8c3.5,0,6.1,1.4,7.7,4.2c1.6,2.8,2.4,7,2.4,12.6 v45.5h28.8V87.8c0-9.7-2.6-17.3-7.7-22.6c-5.1-5.4-12.3-8-21.5-8c-5.6,0-10.6,1-15,2.9c-4.3,2-7.7,4.9-10.2,8.8h-1.7l-3.6-10.3 h-21.7v83.5h28.8V105.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M829.5,117.6c-5.3,2.1-11.3,3.2-14.7,3.2c-5.2,0-7.8-2.7-7.8-8.1V80.2h20.5V58.6H807V37.8h-18.9l-7.4,21.7 l-12.8,9.1v11.7H778v34.4c0,9.8,2.1,17.1,6.4,21.8c4.3,4.7,11.2,7.1,20.9,7.1c4.7,0,8.8-0.4,12.3-1.1c3.5-0.7,8.2-2.4,12.1-4.1 c-0.9-2.6-1.5-5.2-1.7-8.1C827.6,125.9,828.2,121.6,829.5,117.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M995,2.4l-77.9,34.3c-0.6,0.2-0.4,1.1,0.2,1.1l33-0.2c0.2,0.5,0.2,0.5,0.4,1c-20.5,18.1-50,44.1-71.6,63.2 c3.2,2.4,6,5.3,8.2,8.7c20.8-20.3,48.5-47.1,68.2-66.2c0.4-0.4,1-0.1,1,0.4l-0.3,30.5c0,0.6,0.8,0.8,1.1,0.3 C963.6,63.2,995,2.4,995,2.4C995,2.4,995,2.4,995,2.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M831.9,143.3l-70.6,62.2c-0.2,0.2-0.6,0.2-0.8,0L719,163c-0.2-0.2-0.6-0.2-0.8,0l-78.9,78.7 c-0.5,0.5,0.2,1.3,0.8,0.9l76.5-60.6c0.2-0.2,0.6-0.2,0.8,0.1l41.9,50.8c0.2,0.3,0.6,0.3,0.8,0l82.1-78.3 C837.9,151.6,834.4,147.8,831.9,143.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M858.9,112.4c-8.5,0.7-14.8,8.1-14.1,16.6c0.7,8.5,8.1,14.8,16.6,14.1c8.5-0.7,14.8-8.1,14.1-16.6 C874.8,118,867.4,111.7,858.9,112.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M646.2,52.2c8,0,14.4-6.4,14.4-14.4c0-8-6.4-14.4-14.4-14.4c-8,0-14.4,6.4-14.4,14.4 C631.8,45.7,638.2,52.2,646.2,52.2z"
}));

var SvgProfitpointLogoFa = function SvgProfitpointLogoFa(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "artwork",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 245",
    style: {
      enableBackground: "new 0 0 1000 245"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProfitpointLogoFa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profitpoint_logo_FA.175935ad.svg";
export { ForwardRef as ReactComponent };